export const tableSortFn = (data, sortHeaderId: string) => {
  return getPropertyByPath(data, sortHeaderId);
};

// It gets data from nested objects, by path provided in cdkColumnDef
export const getPropertyByPath = (obj: Object, pathString: string) => {
  return pathString.split('.').reduce((o, i) => o[i], obj);
};

export const prepareProperty = (value: any) => {
  if (value) {
    const propertyType = typeof value;
    if (isFinite(value)) {
      return parseInt(value, 10);
    } else if ('string' === propertyType) {
      return value.toLowerCase();
    }
    return value;
  }
};

export const compareSortFn = (a: string | number, b: string | number, isAsc: boolean) => {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
